/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type AreaOfStudyEntity, areaOfStudySchema } from '@axiom/domain';
import { AreaOfStudyCategory } from '../../../enums/generated/area-of-study-category';

/** CreateAreasOfStudyResponse — dark-roast DTO: PostAreaOfStudyResponseDto */
export const createAreasOfStudyResponseSchema = areaOfStudySchema.pick({ "id": true, "name": true }).extend({ "category": z.nativeEnum(AreaOfStudyCategory).nullish(), "isStem": z.boolean() });
export type CreateAreasOfStudyResponse = Pick<AreaOfStudyEntity, "id" | "name"> & z.infer<typeof createAreasOfStudyResponseSchema>;
